import { html, on, View } from 'rune-ts';
import klass from './ButtonFilter.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { shareFont } from '@services/MarppleShop/shared/typography';

export interface ButtonFilterProps {
  label: string;
  is_active?: boolean;
  klass?: string;
  size?: 'normal' | 'small';
}

export class ButtonFilter extends View<ButtonFilterProps> {
  getSelectedStatus(): boolean {
    return this.data.is_active ?? false;
  }

  @on('click')
  public toggle() {
    this.setStatus(!this.getSelectedStatus());
  }

  public setStatus(is_active: boolean) {
    this.data.is_active = is_active;
    if (this.getSelectedStatus()) {
      this.element().classList.add(klass.active);
    } else {
      this.element().classList.remove(klass.active);
    }
  }

  override template() {
    const klasses = classes({
      [shareFont('14_medium')]: true,
      [klass.button_filter]: true,
      [klass.active]: this.getSelectedStatus(),
      [klass[this.data.size ?? '']]: !!klass[this.data.size ?? ''],
      [this.data.klass ?? '']: !!this.data.klass,
    });
    return html`
      <button class="${klasses}" type="button">
        <span class="${klass.text} ${shareFont('14_medium')}">${this.data.label}</span>
        <span class="${klass.bold} ${shareFont('14_medium')}">${this.data.label}</span>
      </button>
    `;
  }
}
